<template>
  <div class="login-page-container">
    <div class="bg">
      <div class="auth-box-w">
        <!-- <div class="logo-w">
          <img alt src="../../assets/images/logo.png" />
        </div> -->
        <h4 class="auth-header">设置新密码</h4>
        <div>
          <div class="form-group">
            <label for>新密码</label>
            <input
              v-model="new_password"
              class="form-control"
              placeholder="请输入新密码"
              type="password"
            />
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
          </div>
          <div class="form-group">
            <label for>确认密码</label>
            <input
              v-model="repeat_password"
              class="form-control"
              placeholder="请确认密码"
              type="password"
            />
          </div>
          <div class="buttons-w">
            <el-button @click="handleNewPassword" type="primary" size="small"
              >确 认</el-button
            >
            <!-- <button :disabled="submiting" class="btn btn-primary">确 认</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { userSet } from '../../service/getData'

export default {
  data() {
    return {
      submiting: false,
      new_password: null,
      repeat_password: null,
      old_password: '88888888',
    }
  },
  created() {},
  methods: {
    async handleNewPassword() {
      if (
        !this.new_password ||
        this.new_password.length < 6 ||
        this.new_password.length > 15
      ) {
        this.$message.error('密码长度为6-15个字符')
        return
      }

      if (this.new_password != this.repeat_password) {
        this.$message.error('两次输入密码不一致')
        return
      }

      this.submiting = true
      let userInfo = store.state.userInfo
      let data = {
        id: userInfo.id,
        new_password: this.new_password,
        repeat_password: this.repeat_password,
        old_password: this.old_password,
      }

      let res = await userSet(data)
      if (res.code == 0) {
        if (store.state.loginRedirect) {
          this.$router.push(store.state.loginRedirect)
        } else {
          this.$router.push('/dashboard')
        }
      }
      this.submiting = false
    },
  },
}
</script>

<style scoped>
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 40px;
  /* background-image: url(../../assets/bg-pattern2.png);
  background-size: contain;
  background-repeat: repeat;
  background-position: 0 0; */
}
.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
.captcha {
  display: flex;
}
.captcha img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.logo-w h2 {
  letter-spacing: 2px;
  font-weight: bold;
}
label {
  margin-bottom: 4px;
}
.auth-box-w {
  padding: 50px 80px;
  max-width: 450px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
}

.auth-box-w.wider {
  max-width: 500px;
}

.auth-box-w .logged-user-w {
  padding-top: 0px;
  padding-bottom: 10px;
}

.auth-box-w .logo-w {
  text-align: center;
  padding: 10%;
}

.auth-box-w .auth-header {
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
  padding-bottom: 1rem;
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
  font-size: 24px;
  /* padding-left: 80px; */
}

/* .auth-box-w .auth-header:after {
  content: '';
  background-color: #047bf8;
  width: 32px;
  height: 7px;
  border-radius: 2px;
  display: block;
  position: absolute;
  bottom: -4px;
} */

.auth-box-w form {
  padding: 20px 80px;
  padding-bottom: 60px;
}

.auth-box-w form .form-check-inline {
  margin-left: 1rem;
}

.auth-box-w form .form-group {
  position: relative;
}

.auth-box-w form .form-group .pre-icon {
  position: absolute;
  bottom: 5px;
  font-size: 24px;
  color: #047bf8;
  left: -38px;
}

.auth-box-w .buttons-w {
  padding-top: 1rem;
  margin-top: 0.5rem;
  /* border-top: 1px solid rgba(0, 0, 0, 0.05); */
}

.form-group {
  font-size: 14px;
}

.auth-box-w.centered {
  text-align: center;
}

.auth-box-w.centered .auth-header {
  padding-left: 0px;
}

.auth-box-w.centered .auth-header:after {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  left: 50%;
}

.flex-row-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-control {
  height: 36px;
}
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 100px;
  /* background-image: url(../../assets/bg-pattern2.png);
  background-size: contain;
  background-repeat: repeat;
  background-position: 0 0; */
}
.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
.captcha {
  display: flex;
}
.captcha img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.logo-w {
  display: flex;
  justify-content: center;
  align-items: bottom;
}
.logo-w h2 {
  font-weight: bold;
  font-size: 26px;
  margin-left: 8px;
  margin-top: 2px;
}
.logo-w img {
  /* width: 113px; */
  /* height: 32px; */
}
label {
  margin-bottom: 4px;
}
/deep/ .login-tabs .el-tabs__nav-scroll {
  padding: 0 80px !important;
}

/deep/ .login-tabs .el-tabs__item.is-active {
  color: #292b2c;
  font-size: 16px;
}
/deep/ .login-tabs .el-tabs__item {
  color: #636c72;
}
.beian-info {
  color: #999;
  opacity: 0.5;
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
</style>